import { PaymentTypeCreate } from './PaymentTypeCreate'
import { PaymentTypeEdit } from './PaymentTypeEdit'
import { PaymentTypeList } from './PaymentTypeList'
import { PaymentTypeShow } from './PaymentTypeShow'

export { PaymentTypeCreate, PaymentTypeEdit, PaymentTypeList, PaymentTypeShow }
